import { useRouter } from '@uirouter/react'
// helpers
import get from 'lodash/get'
import map from 'lodash/map'
import drop from 'lodash/drop'
import every from 'lodash/every'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import getNavType from './getNavType'
import getStateTree from './getStateTree'
// Antd
import { Menu } from 'antd'
import Layout from 'antd/lib/layout'
import Logo from './Logo'
import authService from 'authService'

const getItem = (
  label: string,
  key: string,
  icon: React.ReactNode,
  children?: React.ReactNode,
  type?: any
) => ({
  key,
  icon,
  children,
  label,
  type
})

const menuItem = ({ title, name, _children, data, roles }: any) => {
  if (!isEmpty(roles) && every(roles, (rol) => !authService.state.roles.includes(rol))) return []
  if (_children.length) {
    return getItem(title, name, get(data, 'nav.icon', null), _children.flatMap(menuItem))
  }

  return getItem(title, name, get(data, 'nav.icon', null))
}
const SideMenu: React.FC = () => {
  const { stateService } = useRouter()
  const states = cloneDeep(stateService.get())
  const menu = getNavType(states, 'menu')
  const statesMenu = getStateTree(menu, 2)
  const selectedKeys = drop(
    map(stateService.$current.includes, (_: any, key: any) => key),
    2
  )

  const propsMenu = {
    selectedKeys,
    mode: 'inline' as 'inline',
    items: statesMenu.flatMap(menuItem),
    onClick: ({ key }: { key: string }) => key !== '.' && stateService.go(key),
    defaultOpenKeys: selectedKeys,
    defaultSelectedKeys: selectedKeys
  }

  return (
    <Layout.Sider>
      <Logo />
      <Menu {...propsMenu} />
    </Layout.Sider>
  )
}

export default SideMenu
